import {
  GET_MASTER_DATA,
  GET_MASTER_DATA_SUCCESS,
  GET_MASTER_DATA_FAILURE,
} from 'store/masterData/masterDataAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getMasterDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MASTER_DATA:
      return { ...state, loading: true };
    case GET_MASTER_DATA_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_MASTER_DATA_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getMasterDataReducer;
